import { PermissionDenied } from '@/components/ui/permission-denied';
import { useSession } from '@/stores/session';
import { BotsCard } from '../components/BotsCard';

/**
 * Admin page for server-to-server access — service bots and personal access
 * tokens (ADR-081). Founder / Super Admin only; the route + nav are gated, this
 * is the defense-in-depth check.
 */
export function ApiKeysPage() {
  const role = useSession((s) => s.role);
  const canManage = role === 'founder' || role === 'super_admin';

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-semibold tracking-tight">API keys &amp; bots</h1>
        <p className="text-muted-foreground text-sm">
          Server-to-server access for trusted automations (e.g. the MCP server). Each key acts
          with the roles you grant it, scoped to this organization.
        </p>
      </div>

      {canManage ? <BotsCard /> : <PermissionDenied />}
    </div>
  );
}
